export default "__VITE_ASSET__gHS7OTSA__"